import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c3ffe8e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "25 25 50 50" }, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "50",
    cy: "50",
    r: "20",
    fill: "none",
    "stroke-width": "4",
    "stroke-miterlimit": "10"
  })
], -1))
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["md-progress-indicator-circular", [_ctx.size]])
  }, _hoisted_2, 2))
}